import { managePagesExperienceId } from '@atlassian/help-center-common-util/analytics/ufo';
import { ExperiencePerformanceTypes, ExperienceTypes, UFOExperience } from '@atlassian/ufo';

export const managePagesExperience = new UFOExperience(managePagesExperienceId, {
    type: ExperienceTypes.Load,
    performanceType: ExperiencePerformanceTypes.PageLoad,
});
